var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mt-2 slide-in-top",attrs:{"header":_vm.heading,"border-variant":"light","header-bg-variant":"dark","header-text-variant":"navy"}},[_c('b-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }